module.exports = __webpack_public_path__ + "static/ogre_zombie-10053ef512ff6864575940c138d7b4da.jpeg";